import { SetState } from '@store/store.type';
import {
  getHitsAchievement,
  GetHitsAchievementPayloadType,
  getProjectsAchievement,
  GetProjectsAchievementPayloadType,
  getProjects,
  GetProjectsPayloadType,
} from '@api';
import { getApiError } from '@store/helper';
import { hitAchievementApiMapper, projectAchievementApiMapper, projectApiMapper } from '@mappers';

import { StoreGlobalType } from '../store';

import { ProjectSliceType } from './project.slice';

/****************************************************************
 * GET PROJECTS
 *****************************************************************/

type GetProjectsAvailableActionStatusType =
  | 'getProjects/loading'
  | 'getProjects/succeeded'
  | 'getProjects/failed';

export type GetProjectsActionPayloadType = GetProjectsPayloadType;

export const getProjectsAction =
  (
    set: SetState<
      Partial<ProjectSliceType & StoreGlobalType>,
      GetProjectsAvailableActionStatusType,
      GetProjectsActionPayloadType
    >,
  ) =>
    async (payload: GetProjectsActionPayloadType) => {
      try {
        set(
          (state) => {
            state.getProjectsAction.status = 'LOADING';
            state.error = undefined;
            state.success = undefined;
          },
          false,
          { type: 'getProjects/loading', payload },
        );

        const projectsApi = await getProjects(payload);
        const projects = projectsApi?.map(projectApiMapper);

        set(
          (state) => {
            state.getProjectsAction.status = 'SUCCEEDED';
            state.projectsFiltered = projects;
          },
          false,
          { type: 'getProjects/succeeded' },
        );
      } catch (e) {
        set(
          (state) => {
            state.getProjectsAction.status = 'FAILED';
            state.projectsFiltered = [];
            state.error = getApiError(e);
          },
          false,
          { type: 'getProjects/failed' },
        );
      }
    };

/****************************************************************
 * GET PROJECTS ACHIEVEMENT
 *****************************************************************/

type GetProjectsAchievementActionStatusType =
  | 'getProjectsAchievement/loading'
  | 'getProjectsAchievement/succeeded'
  | 'getProjectsAchievement/failed';

export type GetProjectsAchievementActionPayloadType = GetProjectsAchievementPayloadType;

export const getProjectsAchievementAction =
  (
    set: SetState<
      Partial<ProjectSliceType & StoreGlobalType>,
      GetProjectsAchievementActionStatusType,
      GetProjectsAchievementActionPayloadType
    >,
  ) =>
    async (payload: GetProjectsAchievementActionPayloadType) => {
      try {
        set(
          (state) => {
            state.getProjectsAchievementAction.status = 'LOADING';
            state.error = undefined;
            state.success = undefined;
          },
          false,
          { type: 'getProjectsAchievement/loading', payload },
        );

        const projectsAchievementApi = await getProjectsAchievement(payload);
        const projectsAchievement = projectsAchievementApi?.map(projectAchievementApiMapper);

        set(
          (state) => {
            state.getProjectsAchievementAction.status = 'SUCCEEDED';
            state.projectsAchievementFiltered = projectsAchievement;
          },
          false,
          { type: 'getProjectsAchievement/succeeded' },
        );
      } catch (e) {
        set(
          (state) => {
            state.getProjectsAchievementAction.status = 'FAILED';
            state.projectsAchievementFiltered = [];
            state.error = getApiError(e);
          },
          false,
          { type: 'getProjectsAchievement/failed' },
        );
      }
    };

/****************************************************************
 * GET HITS ACHIEVEMENT
 *****************************************************************/

type GetHitsAchievementActionStatusType =
  | 'getHitsAchievement/loading'
  | 'getHitsAchievement/succeeded'
  | 'getHitsAchievement/failed';

export type GetHitsAchievementActionPayloadType = GetHitsAchievementPayloadType;

export const getHitsAchievementAction =
  (
    set: SetState<
      Partial<ProjectSliceType & StoreGlobalType>,
      GetHitsAchievementActionStatusType,
      GetHitsAchievementActionPayloadType
    >,
  ) =>
    async (payload: GetHitsAchievementActionPayloadType) => {
      try {
        set(
          (state) => {
            state.getHitsAchievementAction.status = 'LOADING';
            state.error = undefined;
            state.success = undefined;
          },
          false,
          { type: 'getHitsAchievement/loading', payload },
        );

        const hitsAchievementApi = await getHitsAchievement(payload);
        const hitsAchievement = hitsAchievementApi?.map(hitAchievementApiMapper);

        set(
          (state) => {
            state.getHitsAchievementAction.status = 'SUCCEEDED';
            state.hitsFiltered = hitsAchievement;
          },
          false,
          { type: 'getHitsAchievement/succeeded' },
        );
      } catch (e) {
        set(
          (state) => {
            state.getHitsAchievementAction.status = 'FAILED';
            state.hitsFiltered = [];
            state.error = getApiError(e);
          },
          false,
          { type: 'getHitsAchievement/failed' },
        );
      }
    };
